import { useAppSelector } from '@application/store/useStore';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
export default function DebtorTabsHelpers() {
    const { unchangedDebtor } = useAppSelector((state) => state.debtors);
    const [infoTabErrorBorderColor, setInfoTabErrorBorderColor] = useState(false);
    const [isPriceAgreementTabBold, setIsPriceAgreementTabBold] = useState(false);
    const [isInfoTabBold, setIsInfoTabBold] = useState(false);
    const [isNotesTabBold, setIsNotesTabBold] = useState(false);
    const [formData, setFormData] = useState({
        debtorNumber: 0,
        name: '',
        name2: '',
        email: '',
        phoneNumber: '',
        address: '',
        postalCode: '',
        city: '',
        country: '',
        website: '',
        fax: '',
        invoiceEmail: '',
        // invoiceByEmail: '',
        invoiceAddress: '',
        invoicePostalCode: '',
        invoiceCity: '',
        invoiceCountry: '',
        priceAgreements: '',
        note: ''
        //isApproved:false
        // vat:0
    });
    const [errors, setErrors] = useState({
        debtorNumber: '',
        name: '',
        email: '',
        phoneNumber: '',
        invoiceEmail: ''
    });
    useEffect(() => {
        if (!errors.debtorNumber && !errors.name && !errors.email && !errors.phoneNumber && !errors.invoiceEmail) {
            setInfoTabErrorBorderColor(false);
        }
    }, [errors]);
    const handleFieldChange = (fieldName, value) => {
        setFormData((prevData) => ({
            ...prevData,
            [fieldName]: value
        }));
        setErrors((prevErrors) => ({
            ...prevErrors,
            [fieldName]: '' // Clear the error for this field on every change
        }));
    };
    const handleToggelButtonChange = (fieldName, value) => {
        setFormData((prevData) => ({
            ...prevData,
            [fieldName]: value
        }));
    };
    const handleCalendarChange = (fieldName, value) => {
        setFormData((prevData) => ({
            ...prevData,
            [fieldName]: value
        }));
    };
    const handleTimeCalendarChange = (fieldName, value) => {
        const timeStringValue = value?.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit', hour12: true });
        setFormData((prevData) => ({
            ...prevData,
            [fieldName]: timeStringValue
        }));
    };
    useEffect(() => {
        checkBoldFieldsDebtor();
        unchangedFieldsDebtor();
    }, [formData, unchangedDebtor]);
    const validateForm = () => {
        const newErrors = {
            debtorNumber: '',
            name: '',
            email: '',
            phoneNumber: '',
            invoiceEmail: ''
        };
        if (!formData.debtorNumber) {
            newErrors.debtorNumber = 'Dit veld is verplicht';
            setInfoTabErrorBorderColor(true);
        }
        if (formData.name === '') {
            newErrors.name = 'Dit veld is verplicht';
            setInfoTabErrorBorderColor(true);
        }
        if (formData.email === '') {
            newErrors.email = 'Dit veld is verplicht';
            setInfoTabErrorBorderColor(true);
        }
        else if (!/[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/.test(formData.email)) {
            newErrors.email = 'Ongeldig e-mailadres';
            setInfoTabErrorBorderColor(true);
        }
        if (formData.phoneNumber === '') {
            newErrors.phoneNumber = 'Dit veld is verplicht';
            setInfoTabErrorBorderColor(true);
        }
        if (formData.invoiceEmail === '' || formData.invoiceEmail === null) {
            newErrors.invoiceEmail = 'Dit veld is verplicht';
            setInfoTabErrorBorderColor(true);
        }
        else if (formData.invoiceEmail && !/[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/.test(formData.invoiceEmail)) {
            newErrors.invoiceEmail = 'Ongeldig e-mailadres';
            setInfoTabErrorBorderColor(true);
        }
        setErrors(newErrors);
        return newErrors;
    };
    //---------------------Module Lock Functionality----------------------------
    const [isInfoTabUnsaved, setInfoTabUnsaved] = useState(false);
    const [isPriceAgreementsTabUnsaved, setPriceAgreementsTabUnsaved] = useState(false);
    const [isTechnicalNotesTabUnsaved, setTechnicalNotesTabUnsaved] = useState(false);
    const { id } = useParams();
    const unchangedFieldsDebtor = () => {
        if (unchangedDebtor && formData && id) {
            let isInfoTabUnsaved = false;
            let isPriceAgreementsTabUnsaved = false; //this is because sometimes i have to change it to false back.
            let isTechnicalNotesTabUnsaved = false;
            // Check for unsaved changes in the Info tab
            if (unchangedDebtor.name !== formData.name ||
                unchangedDebtor.name2 !== formData.name2 ||
                unchangedDebtor.email !== formData.email ||
                unchangedDebtor.phoneNumber !== formData.phoneNumber ||
                unchangedDebtor.address != formData.address ||
                unchangedDebtor.postalCode != formData.postalCode ||
                unchangedDebtor.city != formData.city ||
                unchangedDebtor.country != formData.country ||
                unchangedDebtor.website != formData.website ||
                unchangedDebtor.fax != formData.fax ||
                unchangedDebtor.invoiceEmail != formData.invoiceEmail ||
                unchangedDebtor.vat != formData.vat ||
                unchangedDebtor.invoiceByEmail != formData.invoiceByEmail ||
                unchangedDebtor.invoiceBySameAddress != formData.invoiceBySameAddress ||
                unchangedDebtor.invoiceAddress != formData.invoiceAddress ||
                unchangedDebtor.invoicePostalCode != formData.invoicePostalCode ||
                unchangedDebtor.invoiceAttention != formData.invoiceAttention ||
                unchangedDebtor.invoiceCity != formData.invoiceCity ||
                unchangedDebtor.invoiceCountry != formData.invoiceCountry) {
                isInfoTabUnsaved = true; //if we assign state directly it would automatically be triggered.
            }
            // Check for unsaved changes in the Price Agreements
            if (unchangedDebtor.priceAgreements !== formData.priceAgreements) {
                isPriceAgreementsTabUnsaved = true;
            }
            // Check for unsaved changes in the Technical Notes
            if (formData.note !== unchangedDebtor.note) {
                isTechnicalNotesTabUnsaved = true;
            }
            // Set unsaved state for all tabs
            setInfoTabUnsaved(isInfoTabUnsaved); //if we assign state directly it would automatically be triggered.
            setPriceAgreementsTabUnsaved(isPriceAgreementsTabUnsaved);
            setTechnicalNotesTabUnsaved(isTechnicalNotesTabUnsaved);
        }
    };
    const checkBoldFieldsDebtor = () => {
        if (formData.debtorNumber ||
            formData.name ||
            formData.name2 ||
            formData.email ||
            formData.phoneNumber ||
            formData.address ||
            formData.postalCode ||
            formData.city ||
            formData.country ||
            formData.website ||
            formData.fax ||
            formData.invoiceEmail ||
            formData.vat ||
            formData.invoiceByEmail ||
            formData.invoiceBySameAddress ||
            formData.invoiceAddress ||
            formData.invoicePostalCode ||
            formData.invoiceAttention ||
            formData.invoiceCity ||
            formData.invoiceCountry) {
            setIsInfoTabBold(true);
        }
        if (formData.priceAgreements) {
            setIsPriceAgreementTabBold(true);
        }
        else {
            setIsPriceAgreementTabBold(false);
        }
        if (formData.note) {
            setIsNotesTabBold(true);
        }
        else {
            setIsNotesTabBold(false);
        }
    };
    return {
        handleFieldChange,
        handleToggelButtonChange,
        handleCalendarChange,
        handleTimeCalendarChange,
        validateForm,
        formData,
        setFormData,
        errors,
        infoTabErrorBorderColor,
        isInfoTabUnsaved,
        isPriceAgreementsTabUnsaved,
        isTechnicalNotesTabUnsaved,
        isInfoTabBold,
        isPriceAgreementTabBold,
        isNotesTabBold
    };
}
